import React from "react";
import Linkify from "react-linkify";

export default ({ post }) => {
  return (
    <Linkify
      properties={{
        target: "_blank",
        style: { color: "red", fontWeight: "bold" },
      }}
    >
      <p className="textContent">{post.data.content}</p>
    </Linkify>
  );
};
